import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ProjectSetupHResponse } from '@app/models/project-setup.models';

export interface SectionHFormGroup {
  additionalCosts: FormControl<string | null>;
  furtherInformation: FormControl<string | null>;
  howToComplain: FormControl<string | null>;
  exitOptions: FormControl<string | null>;
}

export function getSectionHFormGroup(
  fb: FormBuilder
): FormGroup<SectionHFormGroup> {
  return fb.nonNullable.group({
    additionalCosts: fb.nonNullable.control<string | null>(null),
    furtherInformation: fb.nonNullable.control<string | null>(null),
    howToComplain: fb.nonNullable.control<string | null>(null),
    exitOptions: fb.nonNullable.control<string | null>(null),
  });
}

export function getSectionHUpdateData(
  formGroup: FormGroup<SectionHFormGroup>
): ProjectSetupHResponse {
  return {
    feesAndCostsChargedToInvestorIncludingAdministrativeCostsFromSaleOfCrowdfundingAssets:
      formGroup.controls.additionalCosts.value,
    whereAndHowToObtainFreeInformationOnCrowdfundingProjectProjectOwnerAndSpecialPurposeEntity:
      formGroup.controls.furtherInformation.value,
    howAndWhereInvestorCanComplainAboutInvestmentOrConductOfProjectOwnerOrCrowdfundingServiceProvider:
      formGroup.controls.howToComplain.value,
    exitOptionsForInvestor: formGroup.controls.exitOptions.value,
  };
}

export function patchSectionHFormWithProjectSetupHResponse(
  formGroup: FormGroup<SectionHFormGroup>,
  response: ProjectSetupHResponse
): FormGroup<SectionHFormGroup> {
  formGroup.setValue({
    additionalCosts:
      response.feesAndCostsChargedToInvestorIncludingAdministrativeCostsFromSaleOfCrowdfundingAssets,
    furtherInformation:
      response.whereAndHowToObtainFreeInformationOnCrowdfundingProjectProjectOwnerAndSpecialPurposeEntity,
    howToComplain:
      response.howAndWhereInvestorCanComplainAboutInvestmentOrConductOfProjectOwnerOrCrowdfundingServiceProvider,
    exitOptions: response.exitOptionsForInvestor,
  });
  return formGroup;
}
